/* eslint-disable jsx-a11y/no-redundant-roles */
import { HashLink } from "react-router-hash-link";
import logo from "../assets/images/logo.jpg";
import {
  BuildingOffice2Icon,
  PhoneIcon,
  EnvelopeIcon,
  IdentificationIcon
} from "@heroicons/react/24/outline";

const navigation = {
  home: [
    { name: "Our Services", link: "/#Features" },
    { name: "Certifications", link: "/#Certifications" },
    { name: "Meet the Team", link: "/#Team" },
    { name: "Customer Reviews", link: "/#Reviews" },
    { name: "Request a Free Inspection", link: "/#FreeQuote" },
  ],
  services: [
    { name: "NCJUA Incentives", link: "/services#NCJUA" },
    { name: "Coatings Division", link: "/services#CoatingDivision" },
    { name: "GAF Timberline Solar™", link: "/services#Solar" },
    { name: "Fortified Roofs", link: "/services#FortifiedRoof" },
  ],
};

export default function Example() {
  return (
    <footer className="bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8 lg:py-32">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <HashLink smooth to={"/#Hero"}>
            <img
              alt="Hide Tide Roofing"
              src={logo}
              // using filter invert to change logo from black to white, may need to adjust depending on new logo
              className="h-9 filter invert"
            />
          </HashLink>
          <div className="mt-16 grid grid-cols-2 gap-8 sm:grid-cols-3 xl:col-span-2 xl:mt-0">
            {/* home column */}
            <div>
              <HashLink smooth to={"/#Hero"}>
                <h3 className="text-sm/6 font-semibold text-white">Home</h3>
              </HashLink>
              <ul role="list" className="mt-6 space-y-4">
                {navigation.home.map((item) => (
                  <li key={item.name}>
                    <HashLink
                      smooth
                      to={item.link}
                      className="text-sm/6 text-gray-400 hover:text-white"
                    >
                      {item.name}
                    </HashLink>
                  </li>
                ))}
              </ul>
            </div>
            {/* services column */}
            <div>
              <HashLink smooth to={"/Services#ServiceHeader"}>
                <h3 className="text-sm/6 font-semibold text-white">Services</h3>
              </HashLink>
              <ul role="list" className="mt-6 space-y-4">
                {navigation.services.map((item) => (
                  <li key={item.name}>
                    <HashLink
                      smooth
                      to={item.link}
                      className="text-sm/6 text-gray-400 hover:text-white"
                    >
                      {item.name}
                    </HashLink>
                  </li>
                ))}
              </ul>
            </div>
            {/* contact column */}
            <div className="col-span-2 sm:col-span-1">
              <HashLink smooth to={"/#FreeQuote"}>
                <h3 className="text-sm/6 font-semibold text-white">
                  Contact Us
                </h3>
              </HashLink>
              <ul role="list" className="mt-6 space-y-4">
                <li className="flex items-start gap-x-4 text-sm/6 text-gray-400">
                  <BuildingOffice2Icon
                    aria-hidden="true"
                    className="flex-none h-7 w-6 text-gray-400"
                  />
                  <span>
                    4608 Mockingbird Ln
                    <br />
                    Wilmington, NC 28409
                  </span>
                </li>
                <li className="flex items-center gap-x-4 text-sm/6 text-gray-400">
                  <PhoneIcon
                    aria-hidden="true"
                    className="flex-none h-7 w-6 text-gray-400"
                  />
                  <a href="tel:+1 (980) 275-9451" className="hover:text-white">
                    +1 (980) 275-9451
                  </a>
                </li>
                <li className="flex items-center gap-x-4 text-sm/6 text-gray-400">
                  <EnvelopeIcon
                    aria-hidden="true"
                    className="flex-none h-7 w-6 text-gray-400"
                  />
                  <a
                    href="mailto:hightideroofingnc@gmail.com"
                    className="hover:text-white"
                  >
                    hightideroofingnc@gmail.com
                  </a>
                </li>
                <li className="flex items-center gap-x-4 text-sm/6 text-gray-400">
                  <IdentificationIcon
                    aria-hidden="true"
                    className="flex-none h-7 w-6 text-gray-400"
                  />
                  <span>RBS 66796</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
